module.exports = __webpack_public_path__ + "img/remainder1.64d05210.svg";